import { Controller } from "@hotwired/stimulus";
import Tablesort from "../lib/tablesort.min.js";

export default class extends Controller {
  connect() {
    new Tablesort(document.getElementById("table-sort"), {
      descending: true,
    });
  }
}
